import React from "react";
import { NoUiSliderElement } from "./noui-slider.element";
import PropTypes from "prop-types";

export function SliderElement({
  onUpdate,
  min,
  max,
  start,
  scaleCourve = null,
  minLabel,
  maxLabel,
  step = 1,
  isCurrency = false,
}) {
  const valueFormat = isCurrency ? "currency" : "integer";

  return (
    <NoUiSliderElement
      onUpdate={onUpdate}
      min={min}
      max={max}
      scaleCourve={scaleCourve}
      start={start}
      step={step}
      minLabel={minLabel}
      maxLabel={maxLabel}
      valueFormat={valueFormat}
    />
  );
}

SliderElement.propTypes = {
  onUpdate: PropTypes.func,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  start: PropTypes.number.isRequired,
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
  step: PropTypes.number,
  isCurrency: PropTypes.bool,
  scaleCourve: PropTypes.object,
};
